import {css} from '@isceco/widget-library2/external/lit'

export default css`
  eform-collapsible {
    margin: 1em 0;
  }

  .two-col {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 0; /* create gutters via padding */
    margin: 0 -8px; /* half-gutter negative margin */
  }

  .two-col > .col {
    padding: 0 8px; /* half-gutter on each side */
    min-width: 0; /* prevent overflow */
  }

  .two-col > .col * {
    margin: 0; /* neutralize component outer margins */
    box-sizing: border-box;
    width: 100%;
  }

  .checkbox-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: start;
    margin-top: -2rem;
  }

  .checkbox-grid isceco-checkbox {
    margin-top: -5px;
    margin-bottom: -5px;
  }

  isceco-checkbox[readonly] {
    --readonly-label-margin-right: 20px;
  }
`
